export enum DocumentStatus {
  Pending = "Pending",
  Published = "Published",
  Archived = "Archived",
}
